var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Eventable } from '@patterns/eventable';
export var PatternBusEvents;
(function (PatternBusEvents) {
    PatternBusEvents["LOADING_START"] = "loading:start";
    PatternBusEvents["LOADING_STOP"] = "loading:stop";
    PatternBusEvents["NIGHT_MODE_TOGGLE"] = "theme:night-mode-toggle";
})(PatternBusEvents || (PatternBusEvents = {}));
var PatternBus = /** @class */ (function (_super) {
    __extends(PatternBus, _super);
    function PatternBus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startLoading = function () {
            _this.notify(PatternBusEvents.LOADING_START);
        };
        _this.stopLoading = function () {
            _this.notify(PatternBusEvents.LOADING_STOP);
        };
        _this.toggleNightMode = function () {
            _this.notify(PatternBusEvents.NIGHT_MODE_TOGGLE);
        };
        return _this;
    }
    Object.defineProperty(PatternBus, "instance", {
        get: function () {
            return instance;
        },
        enumerable: false,
        configurable: true
    });
    return PatternBus;
}(Eventable));
export { PatternBus };
var instance = new PatternBus();
//# sourceMappingURL=pattern_bus.js.map